<template>
  <div class="upload-partner-logos">
    <SinglePartnerLogo
      v-for="(el, idx) in itemsArr"
      :key="idx"
      :index="idx"
      :el="el"
      :isLast="isLast(idx)"
      :controls="itemsArr.length !== 1"
      @addNewItem="handleAddNewItem"
      @removeItem="handleRemoveItem"
      @pushDownItem="handlePushDownItem"
      @pushUpItem="handlePushUpItem"
      @domainValue="handleDomainValue"
      @heightValue="handleHeightValue"
      @widthValue="handleWidthValue"
      @partnerLogoImage="handlePartnerLogoImage"
    />
  </div>
</template>

<script>
import SinglePartnerLogo from './SinglePartnerLogo.vue'
export default {
  components: {
    SinglePartnerLogo,
  },
  props: {
    dataArr: {
      type: Array,
    },
  },
  data() {
    return {
      itemsArr: [
        {
          img: '',
          width: '',
          height: '',
          domain: '',
        },
      ],
    }
  },
  watch: {
    dataArr: {
      deep: true,
      handler() {
        this.init()
      },
    },
    itemsArr: {
      deep: true,
      handler() {
        this.$emit('arrChange', this.itemsArr)
      },
    },
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      if (this.dataArr) {
        const dataArrCopy = JSON.parse(JSON.stringify(this.dataArr))
        this.itemsArr = dataArrCopy.map((el) => {
          return {
            img: el.image,
            domain: el.url,
            width: '',
            height: '',
          }
        })
        if (this.itemsArr.length == 0)
          this.itemsArr.push({
            img: '',
            width: '',
            height: '',
            domain: '',
          })
      }
    },
    handleAddNewItem() {
      this.itemsArr.push({
        img: '',
        width: '',
        height: '',
        domain: '',
      })
      console.log(this.itemsArr)

      this.$emit('dataChange', this.itemsArr)
    },
    handleRemoveItem(index) {
      let item = this.itemsArr.splice(index, 1)

      this.$emit('dataChange', this.itemsArr)
    },
    handlePushDownItem(index) {
      if (index + 1 == this.itemsArr.length - 1) return
      let item = this.itemsArr.splice(index, 1)
      this.itemsArr.splice(index + 1, 0, item[0])

      this.$emit('dataChange', this.itemsArr)
    },
    handlePushUpItem(index) {
      // if (index == this.itemsArr.length - 1) return;
      let item = this.itemsArr.splice(index, 1)
      console.log(item[0])
      this.itemsArr.splice(index - 1, 0, item[0])

      this.$emit('dataChange', this.itemsArr)
    },
    handleHeightValue(obj) {
      this.$emit('emitHeight', obj.height)
      this.itemsArr[obj.id].height = obj.height

      this.$emit('dataChange', this.itemsArr)
    },
    handleWidthValue(obj) {
      this.$emit('emitWidth', obj.width)
      this.itemsArr[obj.id].width = obj.width

      this.$emit('dataChange', this.itemsArr)
    },
    handleDomainValue(obj) {
      this.itemsArr[obj.id].domain = obj.domain

      this.$emit('dataChange', this.itemsArr)
    },
    handlePartnerLogoImage(obj) {
      this.$emit('dataChange', this.itemsArr)
      this.$emit('partnerLogoImage', obj)
    },
    isLast(index) {
      return index === this.itemsArr.length - 1
    },
  },
}
</script>

<style scoped lang="scss"></style>
